import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useEventType } from 'features/event_type_provider';
import { PanelContentContainer, PanelContentHeader, PanelContentTitle } from '../styles';
import { determineTextNotifications, determineTextWorkflows } from './helpers';
const textContainerCss = "t13l1cdh";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, props.className)} />;
});
export const TextMessageSection = ({
  workflows
}) => {
  const eventType = useEventType();
  const hasTextNotifications = determineTextNotifications(eventType);
  const hasTextWorkflows = determineTextWorkflows(workflows);
  const showTextMessageSection = hasTextNotifications || hasTextWorkflows;
  if (!showTextMessageSection) return null;
  return <PanelContentContainer section>
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.text_message')}
        </PanelContentTitle>
      </PanelContentHeader>
      <TextContainer>
        <BodyText>{I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.text_message_helper_text')}</BodyText>
      </TextContainer>
    </PanelContentContainer>;
};

require("./text_message_section.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./text_message_section.js");